import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { TextInput, Select, Button } from 'advenio-components'
import { Grid as OriginalGrid, Row, Col } from 'react-flexbox-grid'
import R, { composeWith, clone } from 'ramda'
import { render } from 'react-dom'
import { Form } from 'formsy-react-2'

import CompaniesActions from '../../Data/Redux/CompaniesRedux'

const ButtonsRow = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin: 16px 0 16px 0;
  width: 100%;
`
export const Grid = styled(props => (
  <OriginalGrid fluid {...props}>
    {props.children}
  </OriginalGrid>
))`
  width: 100% !important;
  padding-left: 0 !important;
`
export const UsoCFDIKeys = [
  { id: 'G01', regimens: [601, 603, 606, 612, 620, 621, 622, 623, 624, 625, 626] },
  { id: 'G02', regimens: [601, 603, 606, 612, 620, 621, 622, 623, 624, 625, 626] },
  { id: 'G03', regimens: [601, 603, 606, 612, 620, 621, 622, 623, 624, 625, 626] },
  { id: 'I01', regimens: [601, 603, 606, 612, 620, 621, 622, 623, 624, 625, 626] },
  { id: 'I02', regimens: [601, 603, 606, 612, 620, 621, 622, 623, 624, 625, 626] },
  { id: 'I03', regimens: [601, 603, 606, 612, 620, 621, 622, 623, 624, 625, 626] },
  { id: 'I04', regimens: [601, 603, 606, 612, 620, 621, 622, 623, 624, 625, 626] },
  { id: 'I05', regimens: [601, 603, 606, 612, 620, 621, 622, 623, 624, 625, 626] },
  { id: 'I06', regimens: [601, 603, 606, 612, 620, 621, 622, 623, 624, 625, 626] },
  { id: 'I07', regimens: [601, 603, 606, 612, 620, 621, 622, 623, 624, 625, 626] },
  { id: 'I08', regimens: [601, 603, 606, 612, 620, 621, 622, 623, 624, 625, 626] },
  { id: 'D01', regimens: [605, 606, 608, 611, 612, 614, 607, 615, 625] },
  { id: 'D02', regimens: [605, 606, 608, 611, 612, 614, 607, 615, 625] },
  { id: 'D03', regimens: [605, 606, 608, 611, 612, 614, 607, 615, 625] },
  { id: 'D04', regimens: [605, 606, 608, 611, 612, 614, 607, 615, 625] },
  { id: 'D05', regimens: [605, 606, 608, 611, 612, 614, 607, 615, 625] },
  { id: 'D06', regimens: [605, 606, 608, 611, 612, 614, 607, 615, 625] },
  { id: 'D07', regimens: [605, 606, 608, 611, 612, 614, 607, 615, 625] },
  { id: 'D08', regimens: [605, 606, 608, 611, 612, 614, 607, 615, 625] },
  { id: 'D09', regimens: [605, 606, 608, 611, 612, 614, 607, 615, 625] },
  { id: 'D10', regimens: [605, 606, 608, 611, 612, 614, 607, 615, 625] },
  { id: 'S01', regimens: [601, 603, 605, 606, 608, 610, 611, 612, 614, 616, 620, 621, 622, 623, 624, 607, 615, 625, 626] },
  { id: 'CP01', regimens: [601, 603, 605, 606, 608, 610, 611, 612, 614, 616, 620, 621, 622, 623, 624, 607, 615, 625, 626] },
  { id: 'CN01', regimens: [605] },
]

class CompanyInvoiceInfoForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      optionsRimgentFiscal: [{ id: 0, label: 'Seleciona regimen fiscal', value: 0 }],
      value: '',

      name: '',
      rfc: '',
      address_1: '',
      address_2: '',
      address_locality: '',
      address_state: '',
      address_country: '',
      address_postcode: '',
    }
  }

  componentWillMount() {
    const { datainvoice } = this.props

    if (datainvoice.uso_cfdi_id !== null) {
      this.changeUsoCFDI({ target: { value: datainvoice.uso_cfdi_id } })
    }
  }

  handleSubmit = (data) => {
    this.props.enviainfo(this.props.company_id, data)
  }


  renderRegimenOtions = () => (
    this.props.regimenFiscal.map(relation => ({
      id: relation.sat_key,
      label: `${relation.sat_key} - ${relation.name}`,
      value: relation.sat_key,
    }))
  )

  renderUsoCFDIOtions = () => (
    this.props.uso_cfdi.filter(key => key.sat_key !== 'CP01').map(relation => ({
      id: relation.id,
      label: `${relation.sat_key} - ${relation.name}`,
      value: relation.id,
    }))
  )

  changeUsoCFDI = ({ target: { value } }) => {
    const { uso_cfdi, regimenFiscal } = this.props
    const [usoCFDI] = uso_cfdi.filter(uso => uso.id === Number(value))
    const [UsoCFDIKey] = UsoCFDIKeys.filter(key => key.id === usoCFDI.sat_key)
    const optionsRimgentFiscal = [{ id: 0, label: 'Seleciona regimen fiscal', value: 0 }].concat(clone(regimenFiscal.filter(regimen => UsoCFDIKey.regimens.includes(Number(regimen.sat_key))).map(regimenFiscal => ({
      id: regimenFiscal.sat_key,
      label: `${regimenFiscal.sat_key} - ${regimenFiscal.name}`,
      value: regimenFiscal.sat_key,
    }))))
    this.setState({ optionsRimgentFiscal })
  }

  render() {
    const { datainvoice: { name, rfc, uso_cfdi_id, regimen_fiscal, address_1, address_2, address_locality, address_state, address_country, address_postcode } } = this.props
    const { optionsRimgentFiscal } = this.state


    return (
      <div>
        <Form onSubmit={this.handleSubmit} >
          <Grid>
            <Row>
              <Col sm={6} md={3}>
                <TextInput
                  name="name"
                  label="Nombre"
                  value={name}
                />
              </Col>
              <Col sm={6} md={3}>
                <TextInput
                  name="rfc"
                  label="RFC"
                  value={rfc}
                />
              </Col>
              <Col sm={6} md={3}>
                <Select
                  name="uso_cfdi_id"
                  label="Uso CFDI"
                  placeholder="Seleccione Uso CFDI"
                  options={this.renderUsoCFDIOtions()}
                  onChangeCallback={(e) => { this.changeUsoCFDI(e) }}
                  value={uso_cfdi_id}
                />
              </Col>
              <Col sm={6} md={3}>
                <Select
                  name="regimen_fiscal"
                  label="Regimen Fiscal"
                  // placeholder="Seleccione Regimen fiscal"
                  options={optionsRimgentFiscal}
                  value={regimen_fiscal}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={6} md={6}>
                <TextInput
                  name="address_1"
                  label="Dirección 1"
                  value={address_1}
                />
              </Col>
              <Col sm={6} md={6}>
                <TextInput
                  name="address_2"
                  label="Dirección 2"
                  value={address_2}
                />
              </Col>
            </Row>

            <Row>
              <Col sm={6} md={3}>
                <TextInput
                  name="address_locality"
                  label="Municipio"
                  value={address_locality}
                />
              </Col>
              <Col sm={6} md={3}>
                <TextInput
                  name="address_state"
                  label="Estado"
                  value={address_state}
                />
              </Col>
              <Col sm={6} md={3}>
                <TextInput
                  name="address_country"
                  label="País"
                  value={address_country}
                />
              </Col>
              <Col sm={6} md={3}>
                <TextInput
                  name="address_postcode"
                  label="Código Postal"
                  value={address_postcode}
                />
              </Col>
            </Row>
            <Row>
              <ButtonsRow>
                <Button success type="submit">
                  Guardar
                </Button>
              </ButtonsRow>
            </Row>
          </Grid>


        </Form>
      </div>
    )
  }
}

CompanyInvoiceInfoForm.propTypes = {
  /** An array with the parent's tax information */
  datainvoice: PropTypes.shape({
    /** The name used on any invoices generated for this parent */
    name: PropTypes.string,
    /** The tax identification number (e.g. RFC in Mexico) */
    rfc: PropTypes.string,
    /** The first line of the parent's address used for tax purposes */
    address_1: PropTypes.string,
    /** The second line of the parent's address used for tax purposes */
    address_2: PropTypes.string,
    /** The city/municipality of the parent's address used for tax purposes */
    address_locality: PropTypes.string,
    /** The state of the parent's address used for tax purposes */
    address_state: PropTypes.string,
    /** The country of the parent's address used for tax purposes */
    address_country: PropTypes.string,
    /** The postcode of the parent's address used for tax purposes */
    address_postcode: PropTypes.string,

  }),
  company_id: PropTypes.string.isRequired,
  company: PropTypes.object.isRequired,


}
CompanyInvoiceInfoForm.defaultProps = {
  datainvoice: {
    name: '',
    rfc: '',
    address_1: '',
    address_2: '',
    address_locality: '',
    address_state: '',
    address_country: '',
    address_postcode: '',
    uso_cfdi_id: null,
    regimen_fiscal: null,

  },

}


const mapStateToProps = ({ companies, ...state }) => ({
  loading: companies.getOne.fetching,
  company: companies.getOne.result,
  restoreSuccessful: companies.restore.success,
  user: state.auth.user,
  uso_cfdi: state.uso_cfdi.get.results,
  regimenFiscal: state.regimenFiscal.get.results,
  datainvoice: companies.getOne.result.invoice_details,


})

const mapDispatchToProps = (dispatch, { match }) => ({
  activateCompany: () => dispatch(CompaniesActions.restoreRequest(match.params.id)),
  enviainfo: (company_id, data) => dispatch(CompaniesActions.updateInvoiceDetailsRequest(company_id, data)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CompanyInvoiceInfoForm))



// WEBPACK FOOTER //
// ./src/Containers/CompanyInvoiceInfoForm/CompanyInvoiceInfoForm.jsx